var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "9x24mfb3na",
    d: "M0 0H24V24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-387 -1575) translate(80 1563) matrix(0 -1 -1 0 331 36)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g4exp8jibb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9x24mfb3na"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M13.91 5L6 12.5 13.91 20 15 18.877 8.275 12.5 15 6.122z",
    mask: "url(#g4exp8jibb)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowSelect);
export default __webpack_public_path__ + "static/media/ic_arrow_select.0016834759295c2d868f25bd15c39fe8.svg";
export { ForwardRef as ReactComponent };